import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { maasApi } from '@/api/maas.api'
import type { FormState } from '@/components/Agents/agentFormTypes'
import {
  applyModelCardLimits,
  modelLengthError,
  normalizeModelConfig
} from '@/components/Agents/modelCapabilities'
import { useModelCards } from './useModelCards'

export function useAgentModelCapabilities(form: FormState) {
  const cardsQuery = useModelCards()
  const modelsQuery = useQuery({
    queryKey: ['maas-credential-models', form.api_key_ref],
    queryFn: () => maasApi.listModelsByCredential(form.api_key_ref),
    enabled: Boolean(form.api_key_ref)
  })
  const models = useMemo(
    () => applyModelCardLimits(modelsQuery.data?.items ?? [], cardsQuery.data ?? []),
    [modelsQuery.data, cardsQuery.data]
  )
  const card = cardsQuery.data?.find(item => item.name.trim() === form.model_name.trim())
  const model = models.find(item => item.name.trim() === form.model_name.trim())
  const extraConfig = model ? normalizeModelConfig(form.extraConfig, card, model) : form.extraConfig
  const error = !cardsQuery.data
    ? cardsQuery.error instanceof Error
      ? cardsQuery.error.message
      : '正在加载模型能力目录'
    : !form.api_key_ref
      ? '请选择模型凭证'
      : !modelsQuery.data
        ? '模型列表尚未加载，请重试'
        : !model
          ? form.model_name
            ? '当前模型不可用，请重新选择模型'
            : '请选择可用模型'
          : modelLengthError(extraConfig)
  return { cardsQuery, modelsQuery, models, card, extraConfig, error, ready: !error }
}
